import {createSelector} from '@reduxjs/toolkit'
import { currentBranchApplicationSelector } from './additionalBranchSelector'
import {currentAgentApplicationSelector} from "./collectorApplicationSelector"

const bltDecisionSelector = createSelector(
    [state => state.bltComponents,
    state => state.primaryAgencyApplication.application, 
    currentAgentApplicationSelector,
    currentBranchApplicationSelector
],
    ({bltReview}, primaryApplication, currentAgentApplication, currentBranchApplication) => { 
        const {queueItem} = bltReview

        return {
            queueItem,
            primaryApplication,
            currentAgentApplication,
            currentBranchApplication
        }
    }
)

export const bltDecisionSelect = state => ({
    bltDecision : bltDecisionSelector(state)
})
